module.exports = __webpack_public_path__ + "img/ic-pprev-active.2c9940b3.svg";